<template>
    <div class="register">
        <div class="register-background">
            <h2>Register</h2>
            <form @submit.prevent="register">
                <input v-model="username" placeholder="Username" required />
                <input v-model="email" placeholder="Email" required type="email" />
                <input v-model="password" placeholder="Password" required type="password" />
                <div v-if="!message" class="buttons">
                    <Button type="submit">Register</Button>
                    <Button color="red" @click="cancel">Cancel</Button>
                </div>
                <Button v-if="message" @click="cancel">Return</Button>
            </form>
            <p v-if="message">{{ message }}</p>
        </div>
    </div>
</template>
  
<script lang="ts">
    import { defineComponent, ref } from 'vue';
    import Button from './Button.vue';
    import { useRouter } from 'vue-router';
    import { supabase } from '@/supabase';
    import bcrypt from "bcryptjs";
  
    export default defineComponent({
        name: 'Register',
        components: { Button },
        setup() {
            const router = useRouter();
            const username = ref('');
            const email = ref('');
            const password = ref('');
            const message = ref('');
  
            const register = async () => {
                const salt = bcrypt.genSaltSync(10)
                const hash = bcrypt.hashSync(password.value, salt)

                try {
                    const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
                        email: email.value,
                        password: password.value,
                    });

                    if (signUpError) {
                        message.value = signUpError.message;
                        return;
                    }

                    if (signUpData.user) {
                        const { data: profileData, error: profileError } = await supabase
                            .from('profiles')
                            .insert({
                            user_id: signUpData.user.id,
                            username: username.value,
                            email: email.value,
                            isapproved: false,
                            isadmin: false
                            })
                            .select();

                        if (profileError) {
                            console.error('Erro ao inserir no profiles:', profileError); // <--- IMPORTANTE
                            message.value = profileError.message;
                            return;
                        }

                        message.value = 'Registration successful. Waiting for admin approval.';
                    } else {
                        message.value = 'Registration failed: user not returned from signUp.';
                    }
                } catch (err: any) {
                    message.value = err.message || 'Registration failed';
                }
            };
  
            const cancel = () => {
                router.push('/');
            };

            return { username, email, password, register, message, cancel };
        },
    });
</script>
  
<style lang="scss" scoped>
    .register {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh; /* Ensures the form takes up the full height of the screen */
    }

    .register-background {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 500px;
        height: 400px;
        background-color: #262626;
        border-radius: 6px;
        box-shadow: 5px 5px 20px rgba(255, 255, 255, 0.5);
    }

    h2 {
        color: lightgray;
    }

    form {
        display: flex;
        flex-direction: column;
        width: 300px; /* Adjust width as needed */
    }

    input {
        margin-bottom: 15px;
        padding: 10px;
        font-size: 1em;
    }

    .buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    button {
        width: 140px;
        padding: 10px;
        font-size: 1em;
        cursor: pointer;
    }

    p {
        margin-top: 15px;
        color: white;
    }
</style>
  